/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { BakendHttpResponse } from '../../bakend-http-response';
import { RequestBuilder } from '../../request-builder';

import { BackendPatchedWorkingCapitalParameterRequestDto } from '../../models/backend-patched-working-capital-parameter-request-dto';
import { BackendWorkingCapitalParameterDto } from '../../models/backend-working-capital-parameter-dto';

export interface FinancingSourcesWorkingCapitalParametersPartialUpdate$XWwwFormUrlencoded$Params {
  /**
   * A unique integer value identifying this working capital parameter.
   */
  id: number;
  body?: BackendPatchedWorkingCapitalParameterRequestDto;
}

export function financingSourcesWorkingCapitalParametersPartialUpdate$XWwwFormUrlencoded(
  http: HttpClient,
  rootUrl: string,
  params: FinancingSourcesWorkingCapitalParametersPartialUpdate$XWwwFormUrlencoded$Params,
  context?: HttpContext,
): Observable<BakendHttpResponse<BackendWorkingCapitalParameterDto>> {
  const rb = new RequestBuilder(
    rootUrl,
    financingSourcesWorkingCapitalParametersPartialUpdate$XWwwFormUrlencoded.PATH,
    'patch',
  );
  if (params) {
    rb.path('id', params.id, {});
    rb.body(params.body, 'application/x-www-form-urlencoded');
  }

  return http.request(rb.build({ responseType: 'json', accept: 'application/json', context })).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as BakendHttpResponse<BackendWorkingCapitalParameterDto>;
    }),
  );
}

financingSourcesWorkingCapitalParametersPartialUpdate$XWwwFormUrlencoded.PATH =
  '/api/financing_sources/working_capital_parameters/{id}/';
